import gql from 'graphql-tag'

import { image } from './utils'

export const GLOBALS = gql`
 query GLOBALS($site: [String]) {
  config: globalSet(site: $site, handle: "siteConfig") {
    ... on siteConfig_GlobalSet {
      seo {
        metaTitle
        metaDescription
        metaOgImage {
          ${image}
        }
      }
      metaSuffix
    }
  }
}
`
